export default __webpack_public_path__ + "static/media/bump.0a08e49b.png";